import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FlagIcon from '@material-ui/icons/Flag';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import { useStyles , StyledTableCell , StyledTableRow  } from './ServiceTabOneStyle'


const TableComponent = () => {
    const classes = useStyles();
    return (
        <TableContainer component={Paper} className={classes.tabContainer} style={{ borderRadius: 12 }}>
            <Table className={classes.table} size="medium" aria-label="customized table">
                <TableBody>
                    <StyledTableRow >
                        <StyledTableCell component="th" scope="row">
                            <div className={classes.tabContainerOne}>
                                <p className={classes.tabHeadText}>google-aisa-east2</p>
                                <div className={classes.tabInnerTextDiv}>
                                    <FlagIcon className={classes.tabInnerIcon} />
                                    <p className={classes.tabInnerText}>Hong kong- Google Cloud: Hong kong</p>
                                </div>
                            </div>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow >
                        <StyledTableCell component="th" scope="row">
                            <div className={classes.tabContainerOne}>
                                <p className={classes.tabHeadText}>google-aisa-east2</p>
                                <div className={classes.tabInnerTextDiv}>
                                    <FlagIcon className={classes.tabInnerIcon} />
                                    <p className={classes.tabInnerText}>Hong kong- Google Cloud: Hong kong</p>
                                </div>
                            </div>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow >
                        <StyledTableCell component="th" scope="row">
                            <div className={classes.tabContainerOne}>
                                <p className={classes.tabHeadText}>google-aisa-east2</p>
                                <div className={classes.tabInnerTextDiv}>
                                    <FlagIcon className={classes.tabInnerIcon} />
                                    <p className={classes.tabInnerText}>Hong kong- Google Cloud: Hong kong</p>
                                </div>
                            </div>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow >
                        <StyledTableCell component="th" scope="row">
                            <div className={classes.tabContainerOne}>
                                <p className={classes.tabHeadText}>google-aisa-east2</p>
                                <div className={classes.tabInnerTextDiv}>
                                    <FlagIcon className={classes.tabInnerIcon} />
                                    <p className={classes.tabInnerText}>Hong kong- Google Cloud: Hong kong</p>
                                </div>
                            </div>
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow >
                        <StyledTableCell component="th" scope="row">
                            <div className={classes.tabContainerOne}>
                                <p className={classes.tabHeadText}>google-aisa-east2</p>
                                <div className={classes.tabInnerTextDiv}>
                                    <FlagIcon className={classes.tabInnerIcon} />
                                    <p className={classes.tabInnerText}>Hong kong- Google Cloud: Hong kong</p>
                                </div>
                            </div>
                        </StyledTableCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default function ServiceTabOne() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    return (
        <div className={classes.root}>

            <AppBar elevation={0} position="static" color="default" className={classes.appBar}>
                <div className={'tabsRow'}>
                    <div onClick={() => setValue(0)} className={value === 0 ? classes.selected : classes.notSelected}><p className={value !== 0 ? classes.tabHead : classes.activeTab}>Asia</p></div>
                    <div onClick={() => setValue(1)} className={value === 1 ? classes.selected : classes.notSelected}><p className={value !== 1 ? classes.tabHead : classes.activeTab}>Australia</p></div>
                    <div onClick={() => setValue(2)} className={value === 2 ? classes.selected : classes.notSelected}><p className={value !== 2 ? classes.tabHead : classes.activeTab}>Canada</p></div>
                    <div onClick={() => setValue(3)} className={value === 3 ? classes.selected : classes.notSelected}><p className={value !== 3 ? classes.tabHead : classes.activeTab}>Europe</p></div>
                    <div onClick={() => setValue(4)} className={value === 4 ? classes.selected : classes.notSelected}><p className={value !== 4 ? classes.tabHead : classes.activeTab}>South Africa</p></div>
                    <div onClick={() => setValue(5)} className={value === 5 ? classes.selected : classes.notSelected}><p className={value !== 5 ? classes.tabHead : classes.activeTab}>United States</p></div>
                </div>

            </AppBar>
            {
                value === 0
                    ?
                    <TableComponent />
                    :
                    value === 1
                    ? 
                    <TableComponent />
                    :
                    value === 2 
                    ? 
                    <TableComponent />
                    :
                    value === 3 
                    ? 
                    <TableComponent />
                    :
                    value === 4 
                    ? 
                    <TableComponent />
                    :
                    value === 5 
                    ? 
                    <TableComponent />
                    :
                    null
            }
        </div>
    );
}
